import { useState } from 'react'
import Icon from './Icon.jsx'

/*
 * Collapsible card section — DESIGN.md §11. Clickable header (icon + title +
 * rotating chevron), collapsed by default for secondary content. Used by the
 * invoice form (payment info, misc info).
 */
export default function Collapsible({ title, icon, defaultOpen = false, right, children }) {
  const [open, setOpen] = useState(defaultOpen)
  return (
    <div style={{
      background: 'var(--color-bg-card)', border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-card)', boxShadow: 'var(--shadow-card)', overflow: 'hidden',
    }}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        style={{
          width: '100%', display: 'flex', alignItems: 'center', gap: 12,
          padding: '16px 20px', background: 'transparent', border: 'none', textAlign: 'left',
        }}
      >
        {icon && <span style={{ color: 'var(--color-primary)', display: 'inline-flex' }}><Icon name={icon} size={19} /></span>}
        <span style={{ flex: 1, fontFamily: 'var(--font-title)', fontWeight: 700, fontSize: 15.5, color: 'var(--color-ink)' }}>{title}</span>
        {right}
        <span style={{ color: 'var(--color-text-muted)', display: 'inline-flex', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .2s ease' }}>
          <Icon name="chevron-down" size={18} />
        </span>
      </button>
      {open && <div style={{ padding: '4px 20px 20px' }}>{children}</div>}
    </div>
  )
}
